export const mainCont = {
  display: "flex",
  flexDirection: "column",
  height: "100vh",
};

export const headerCont = {
  //height: "64px",
  pb: "15px",
  width: "100%",
  alignItems: "start",
  justifyItems: "start",
  pt: { mobile: 2, tablet: 2 },
};

export const mainHeaderCont = {
  position: "sticky",
  top: 0,
  zIndex: 10,
  backgroundColor: "white",
};

export const totalAndSearchCont = {
  display: "flex",
  alignItems: "flex-end",
  mb: 4,
};

export const totalCont = {
  display: "flex",
  alignItems: "baseline",
  mt: 1,
  fontWeight: "bold",
};
export const tabsCont = {
  position: "sticky",
  top: 0,
  zIndex: 10,
  backgroundColor: "white",
  "&:before": { display: "none" },
  mb: 2,
  // make this a flex row:
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  px: 3,
};

export const markButton = {
  borderRadius: "12px",
  textTransform: "none",
  bgcolor: "primary.main",
  py: 1,
};

export const contentCont = {
  flex: 1,
  overflowY: "auto",
  px: 3,
  py: 2,
};

export const loadingCont = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const accordionCont = {
  backgroundColor: "transparent",
  boxShadow: "none",
  "&:before": { display: "none" },
  ml: -3,
};

export const accordionDetails = {
  p: 0,
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

export const notificationItem = {
  mainCont: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px",
    padding: "10px",
    boxShadow:
      "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 0px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",

    "&:hover": {
      backgroundColor: "#FF9484",
    },
    "&:hover .actionIcons": {
      visibility: "visible",
      opacity: 1,
    },

    wrapper: {
      // "&:hover .readIndicator": {
      //   bgcolor: (notification: any) =>
      //     notification.isRead ?  "#123257": "#123257",
      // },
      display: "flex",
      flexDirection: "row",
      iconCont: {
        fontSize: 40,
        pr: "10px",
        display: "flex", // ← make the icon container a flex box
        alignItems: "center", // ← center icon vertically (redundant with wrapper)
        justifyContent: "center",
      },
      mainCont: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "flex-start",
        ml: 2,
      },
      actionsGroup: {
        display: "flex",
        alignItems: "center",
      },

      actionIcons: {
        display: "flex",
        alignItems: "center",
        mr: 1,
        visibility: "hidden",
        opacity: 0,
        transition: "opacity 100ms ease",

        // download icon wrapper styling
        "& .downloadWrapper": {
          width: 32,
          height: 32,

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          cursor: "pointer",
          "&:hover": {
            borderRadius: "50%",
            bgcolor: "#fff",
            boxShadow: "0px 1px 4px rgba(0,0,0,0.2)",
          },
        },

        // trash icon styling
        "& .deleteIcon": {
          width: 32,
          height: 32,

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          color: "error.main",
          cursor: "pointer",
          "&:hover": {
            borderRadius: "50%",
            bgcolor: "#fff",
            boxShadow: "0px 1px 4px rgba(0,0,0,0.2)",
          },
        },
        "& .readIcon": {
          width: 32,
          height: 32,

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          cursor: "pointer",
          "&:hover": {
            borderRadius: "50%",
            bgcolor: "#fff",
            boxShadow: "0px 1px 4px rgba(0,0,0,0.2)",
          },
        },
      },

      // the read/unread dot, always visible
      readIndicator: {
        width: 15,
        height: 15,
        borderRadius: "50%",
      },
    },
    infoWrapper: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "end",
      color: "text.secondary",
    },
  },
};

export const cancelButton = {
  borderRadius: "12px",
  color: "#123257",
  width: 85,
  height: 44,
};

export const deleteButton = {
  borderRadius: "12px",
  backgroundColor: "#F93B4C",
  height: 44,
};
